import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useGetInfinityScheduledPosts } from 'src/hook/useGetScheduledPosts'
import { useCommunityDetails } from 'src/pages/CommunityDetails/Posts/context/communityDetailsContext'
import { AVATAR_SIZE } from 'src/utils'

const useSchedulePostsRequest = () => {
  const { idCommunity } = useParams()
  const { community } = useCommunityDetails()

  const infinityReq = useGetInfinityScheduledPosts({
    avatarSize: AVATAR_SIZE,
    id: Number(idCommunity) || Number(community?.id)
  })

  const hasScheduledPosts = useMemo(
    () => infinityReq.data?.pages.some((page) => Number(page.data.length) > 0),
    [infinityReq.data]
  )

  return { infinityReq, hasScheduledPosts }
}

export default useSchedulePostsRequest
